var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"container",staticClass:"container"},[_c('button',{staticClass:"back-button",on:{"click":_vm.backToFront}},[_vm._v("《《《 BACK")]),_c('transition',{attrs:{"name":"fade"}},[(_vm.showAbout)?_c('About'):_vm._e()],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }